import React from 'react';
import PropTypes from 'prop-types';

import FormLabel from '@material-ui/core/FormLabel';

import { LabelText, ChildrenWrapper } from './styles';

const LabelComponent = ({
  title, children, required, hasError, className, forDayPicker, labelAbove,
}) => (
  <FormLabel className={`${className} ${forDayPicker && 'DateInputLabelWrapper'}`}>
    <LabelText hasError={hasError} labelAbove={labelAbove}>
      {title}
      {!!required && <sup>*</sup>}
    </LabelText>
    <ChildrenWrapper hasError={hasError}>
      {children}
    </ChildrenWrapper>
  </FormLabel>
);

LabelComponent.propTypes = {
  children: PropTypes.shape(),
  title: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  forDayPicker: PropTypes.bool,
  labelAbove: PropTypes.bool,
};

export default LabelComponent;
